import type { MouseEvent } from "react";
import { ThemeProvider } from "styled-components";

import { UIFollowButton } from "common/components/UIFollowButton";
import type { TrackPage } from "domains/analytics/types";
import { darkTheme } from "domains/theme/constants/theme";
import { useTopicFollowing } from "domains/topic/components/useTopicFollowing";

type TopicTileFollowButtonProps = {
  id: string;
  name: string;
  isFollowing: boolean;
  pageForTracking?: TrackPage;
};

export const TopicTileFollowButton = ({ id, name, isFollowing, pageForTracking }: TopicTileFollowButtonProps) => {
  const { canFollow, toggleFollow } = useTopicFollowing({
    topicId: id,
    topicName: name,
    isFollowing,
    pageForTracking,
  });

  const onToggleFollowClick = async (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    await toggleFollow();
  };

  if (!canFollow) return null;

  return (
    <ThemeProvider theme={darkTheme}>
      <UIFollowButton isFollowing={isFollowing} onClick={onToggleFollowClick} variant="interactive" />
    </ThemeProvider>
  );
};
